
import React from "react";

const TypingIndicator: React.FC = () => {
  return (
    <div className="inline-block rounded-2xl p-3 animate-pulse-soft bg-white/10 backdrop-blur-md border border-white/20">
      <div className="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default TypingIndicator;
